import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Adonisjs.svg?component
var Adonisjs_exports = /* @__PURE__ */ __exportAll({
	default: () => Adonisjs_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2 11.997C2 20.066 3.934 22 11.997 22 20.066 22 22 20.066 22 11.997 22 3.934 20.06 2 11.997 2S2 3.934 2 11.997m4.034 2.081 3.129-7.132a2.96 2.96 0 0 1 2.828-1.848c1.285 0 2.302.649 2.834 1.848l3.135 7.132c.14.343.263.796.263 1.182 0 1.77-1.243 3.012-3.012 3.012-.606 0-1.084-.153-1.567-.306a5.1 5.1 0 0 0-1.653-.325c-.643 0-1.157.16-1.665.325-.49.153-.968.306-1.55.306A2.89 2.89 0 0 1 5.76 15.26c0-.392.122-.839.27-1.182zm5.963-5.889L8.905 15.2c.919-.429 1.972-.637 3.092-.637 1.084 0 2.18.208 3.06.637z",
		"clip-rule": "evenodd"
	}, null, -1)])]);
}
var Adonisjs_default = { render: render$1 };
//#endregion
export { Adonisjs_exports, Adonisjs_default as default, render$1 as render };

//# sourceMappingURL=Adonisjs.svg_component.js.map